__turbopack_context__.v({
  "emailAlertsContainer": "emailAlertsTextContent-module-scss-module__dIPECa__emailAlertsContainer",
  "emailAlertsTooltipContainer": "emailAlertsTextContent-module-scss-module__dIPECa__emailAlertsTooltipContainer",
  "emailAlertsWrp": "emailAlertsTextContent-module-scss-module__dIPECa__emailAlertsWrp",
  "rowWrp": "emailAlertsTextContent-module-scss-module__dIPECa__rowWrp",
});
